import {artworkMatch, artworkStudioLink, outreachArtwork} from './championArtwork.js'

export function outreachArtworkContext(jobs, champ, returnTo = '') {
  const back = new URL(returnTo.startsWith('/command-center?') ? returnTo : '/command-center', 'https://local.invalid')
  back.searchParams.set('record', String(champ.id));back.searchParams.set('act', 'email')
  const returnPath = back.pathname + back.search
  const link = (jobId, step) => {
    const url = new URL(artworkStudioLink(champ, jobId, returnPath), 'https://local.invalid')
    if (jobId) url.searchParams.set('engineStep', step)
    if (step !== 'review') {url.searchParams.set('tool', 'upload');url.searchParams.set('jobTab', 'files')}
    return url.pathname + url.search
  }
  const eligible = outreachArtwork(jobs, champ)
  const rows = (jobs || []).filter(job => !job.deletedAt && artworkMatch(job, champ) === 'championship').flatMap(job => {
    const engine = job.artworkEngine, outputs = (job.assets || []).filter(asset => asset.role === 'artwork_engine_output')
    return (outputs.length ? outputs : [null]).map(output => {
      const ready = eligible.find(row => row.jobId === job.id && row.output.id === output?.id)
      const current = output && output.id === engine?.outputAssetId && output.engineRevision === engine.revision && (!output.specFingerprint || output.specFingerprint === engine.specFingerprint)
      const reason = ready ? 'Saved original available for outbound. Review is optional.' : !output ? 'No saved original is available for this job.' : 'This file cannot be attached: its saved revision binding, file type or size is not supported.'
      return {jobId:job.id, title:job.title, revision:engine?.revision, output, key:ready?.key, eligible:Boolean(ready), reason,
        uploader:output?.by || 'Not recorded', ownerId:job.ownerId,
        provenance:output?.provenance?.kind || (output?.source==='original_file_import'?'staff_import':output?.source) || (current && (engine?.provenance?.source || engine?.provenance?.kind || engine?.provenance?.generator)) || 'Not recorded',
        reviewUrl:link(job.id, current ? 'review' : 'generate'), addUrl:link(job.id, engine ? 'generate' : 'brief')}
    })
  })
  return {rows, addUrl:rows[0]?.addUrl || link(null, 'brief'), returnPath}
}
